import { IoIosInformationCircleOutline } from 'react-icons/io'

import { DateTimeRange as DateTimeRangeField, toWallClock } from '@/components/ui'

interface Params {
  from?: string
  to?: string
  onChange: ({ from, to }: { from?: string; to?: string }) => void
  help?: React.ReactNode
  className?: string
}

const toUtc = (value?: string) => (value ? new Date(value).toISOString().slice(0, 19) : '')

export const DateTimeRange: React.FC<Params> = ({ from, to, onChange, help, className }) => {
  const thirteenMonthsAgo = new Date()
  thirteenMonthsAgo.setMonth(thirteenMonthsAgo.getMonth() - 13)

  return (
    <DateTimeRangeField
      className={className}
      from={from ? toWallClock(new Date(from)) : undefined}
      to={to ? toWallClock(new Date(to)) : undefined}
      fromLabel="Start Date"
      toLabel="End Date"
      fromPlaceholder="Choose the start date"
      toPlaceholder="Choose the end date"
      minDate={thirteenMonthsAgo.toISOString().slice(0, 10)}
      maxDate={new Date().toISOString().slice(0, 10)}
      onChange={({ from: nextFrom, to: nextTo }) =>
        onChange({ from: toUtc(nextFrom ?? from), to: toUtc(nextTo ?? to) })
      }
      help={
        help || (
          <span className="text-sm font-light text-base-content flex items-center gap-2 p-2 bg-info/20 rounded-md border-info border mt-2">
            <IoIosInformationCircleOutline size={18} className="text-info" />
            Please select a date range within the last 30 Days
          </span>
        )
      }
    />
  )
}
